import React, { useEffect } from "react";

import { GoalNavigationTabs } from "@components/TreatmentPlan/GoalDetails/GoalNavigationTabs";
import { ProgrammingGoalHeader } from "@components/TreatmentPlan/GoalDetails/ProgrammingGoalHeader";
import { ProgrammingGoalOverview } from "@pages/ClientProgramming/ProgrammingGoalOverview/ProgrammingGoalOverview";
import { ProgrammingGoalVideoMoments } from "@pages/ClientProgramming/ProgrammingGoalVideoMoments/ProgrammingGoalVideoMoments";
import { useClientProgrammingData } from "@providers/ClientProgrammingProvider";

interface ProgrammingGoalProps {}
const ProgrammingGoal: React.FC<ProgrammingGoalProps> = () => {
  const { selectedProgrammingGoalTab, isTreatmentPlanUploadEnabled, setSelectedProgrammingGoalTab } =
    useClientProgrammingData();

  useEffect(() => {
    if (!isTreatmentPlanUploadEnabled) {
      setSelectedProgrammingGoalTab("Overview");
    }
  }, [isTreatmentPlanUploadEnabled]);
  return (
    <div>
      <ProgrammingGoalHeader />
      {isTreatmentPlanUploadEnabled && <GoalNavigationTabs />}
      <div
        className={`overflow-y-auto pr-3 ${isTreatmentPlanUploadEnabled ? "max-h-[calc(100vh-20rem)]" : "max-h-[calc(100vh-17.5rem)]"}`}
      >
        {selectedProgrammingGoalTab === "Overview" && <ProgrammingGoalOverview />}
      </div>
      <div>
        {selectedProgrammingGoalTab === "Video Moments" && isTreatmentPlanUploadEnabled && (
          <ProgrammingGoalVideoMoments />
        )}
      </div>
    </div>
  );
};

export default ProgrammingGoal;
